export const encodeRequestPayload = (args) => {
  // Clone input to avoid changing it
  const data = { ...args };

  // eslint-disable-next-line no-restricted-syntax
  for (const key in data) {
    if (
      // eslint-disable-next-line no-prototype-builtins
      data.hasOwnProperty(key) &&
      typeof data[key] !== 'string' &&
      data[key] !== null &&
      data[key] !== undefined
    ) {
      if (typeof data[key] === 'object' || data[key].constructor === Array) {
        data[key] = JSON.stringify(data[key]);
      } else if (typeof data[key] === 'boolean') {
        data[key] = data[key] ? 'true' : 'false';
      } else {
        data[key] = `${data[key]}`;
      }
    }
  }
  return data;
};
